package org.hs_soft.runmynesto.data.api_datasource.product.tabs.tab_price

import kotlinx.serialization.json.Json
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.encodeToJsonElement
import kotlinx.serialization.json.put
import kotlinx.serialization.json.putJsonObject
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.ApiClient
import org.hs_soft.runmynesto.domain.config.Errors
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_price.special_price.SpecialPriceModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.product.tab_price.GetSpecialPriceRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.product.tab_price.UpdateSpecialPriceRepository
import org.hs_soft.runmynesto.domain.util.ApiUtils

class UpdateSpecialPriceRepositoryImpl(
    private val apiClient: ApiClient,
    private val requestManager: RequestManager,
):UpdateSpecialPriceRepository
{
    override suspend fun updateSpecialPrice(
        id: String,
        title: String,
        value: dynamic
    ): SpecialPriceModel {

        val abortController = requestManager.createController()

        val graphQLQuery = buildJsonObject {
            put("query", """
            mutation updateSpecialPrice(${'$'}id: ID!, ${'$'}fields: SpecialPriceFields!) {
              cashAssist {
                updateSpecialPrice(id:${'$'}id, fields: ${'$'}fields) {
                  ${ApiUtils.Field.id}
                  ${ApiUtils.Field.mod_ver}
                  ${ApiUtils.Field.type}
                  ${ApiUtils.Field.weekDays}
                  dateInterval {
                    ${ApiUtils.Field.from}
                    ${ApiUtils.Field.to}
                    ${ApiUtils.Field.__typename}
                  }
                  timeInterval {
                    ${ApiUtils.Field.from}
                    ${ApiUtils.Field.to}
                    ${ApiUtils.Field.__typename}
                  }
                  ${ApiUtils.Field.price}
                  ${ApiUtils.Field.priceInCafe}
                  tradePrice {
                    ${ApiUtils.Field.count}
                    ${ApiUtils.Field.price}
                    ${ApiUtils.Field.__typename}
                  }
                  actionAmount {
                    ${ApiUtils.Field.more}
                    ${ApiUtils.Field.less}
                    ${ApiUtils.Field.__typename}
                  }
                  ${ApiUtils.Field.actionDiscount}
                  ${ApiUtils.Field.actionGroup}
                  ${ApiUtils.Field.fullDiscount}
                  ${ApiUtils.Field.codeMWSt}
                  ${ApiUtils.Field.codeMWSt2}
                  ${ApiUtils.Field.mode}
                  ${ApiUtils.Field.cashRegisterId}
                  ${ApiUtils.Field.name}
                  ${ApiUtils.Field.__typename}
                }
                ${ApiUtils.Field.__typename}
              }
            }

            """.trimIndent())

            put("variables", buildJsonObject {
                put("id", id)
                putJsonObject("fields"){
                    when(value){
                        is String -> put(title,value as String)
                        is Int->put(title,value as Int)
                        is Boolean->put(title,value as Boolean)
                        is List<String?> ->{
                            put(title,Json
                                .encodeToJsonElement(value as List<String?>))
                        }
                        is JsonObject -> put(title, value as JsonObject)
                        is MutableSet<String> ->
                             put(ApiUtils.Field.cashRegisterId,
                              Json.encodeToJsonElement(value as MutableSet<String>))


                    }

                }
            })
        }

        val result = apiClient.requestResult(
            graphQLQuery = graphQLQuery,
            resource = ApiUtils.Cognito.API_URL,
            abortController = abortController,
        )

        return if (result != null) {
            Json.decodeFromString(result.decodeToString())
        } else {
            throw Exception(Errors.timeoutErr)
        }

    }


}